export interface Arc {
  id: string;
  no: string;
  title: string;
  desc: string;
  progress: string;
  image: string;
}

export const arcs: Arc[] = [
  {
    id: "awaken",
    no: "壹",
    title: "双生武魂 · 觉醒",
    desc: "唐三从唐门暗器世界重生到斗罗大陆，拜入武魂殿大师门下，觉醒蓝银草与昊天锤双生武魂，踏上魂师之路。",
    progress: "已收录 · 开篇",
    image: "https://readdy.ai/api/search-image?query=A%20young%20hero%20standing%20on%20a%20misty%20cliff%20with%20glowing%20vines%20of%20blue%20light%20coiling%20around%20his%20arms%2C%20ancient%20chinese%20fantasy%20cultivation%20world%2C%20warm%20golden%20sunrise%20over%20floating%20mountains%2C%20traditional%20ink%20wash%20style%20mixed%20with%20vibrant%20color%2C%20epic%20atmosphere%2C%20high%20detail&width=800&height=560&seq=arc-awaken&orientation=landscape",
  },
  {
    id: "shrek",
    no: "贰",
    title: "史莱克学院 · 七怪聚首",
    desc: "唐三与小舞考入史莱克学院，与戴沐白、朱竹清、奥斯卡、宁荣荣、马红俊组成史莱克七怪，在历练中结下深厚情谊。",
    progress: "已收录",
    image: "https://readdy.ai/api/search-image?query=Seven%20young%20warriors%20standing%20together%20before%20an%20ancient%20wuxia%20academy%20gate%20on%20a%20stone%20courtyard%2C%20traditional%20chinese%20fantasy%20cultivation%20world%2C%20golden%20autumn%20leaves%2C%20warm%20amber%20tones%2C%20ink%20wash%20style%20with%20vibrant%20color%2C%20heroic%20friendship%20mood%2C%20high%20detail&width=800&height=560&seq=arc-shrek&orientation=landscape",
  },
  {
    id: "arena",
    no: "叁",
    title: "全大陆魂师大赛 · 扬名",
    desc: "史莱克七怪参加全大陆高级魂师学院精英大赛，一路过关斩将，向大陆强者证明史莱克的实力与不屈意志。",
    progress: "已收录",
    image: "https://readdy.ai/api/search-image?query=Epic%20arena%20battle%20inside%20an%20ancient%20colosseum%20with%20flying%20sparks%20and%20ring%20energy%20halos%2C%20chinese%20fantasy%20tournament%2C%20dramatic%20golden%20light%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20crowded%20crowd%20atmosphere%2C%20high%20detail&width=800&height=560&seq=arc-arena&orientation=landscape",
  },
  {
    id: "sea",
    no: "肆",
    title: "海神岛 · 九考历练",
    desc: "为突破自我、守护挚爱，唐三踏上海神岛接受海神九考，历经艰险磨砺，魂力与心境不断蜕变升华。",
    progress: "已收录",
    image: "https://readdy.ai/api/search-image?query=Colossal%20ancient%20god%20temple%20on%20a%20cliff%20by%20a%20boundless%20ocean%2C%20huge%20golden%20worship%20pillar%2C%20chinese%20fantasy%20cultivation%20world%2C%20sea%20of%20clouds%2C%20warm%20sunset%20god%20light%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20sacred%20epic%20mood%2C%20high%20detail&width=800&height=560&seq=arc-sea&orientation=landscape",
  },
  {
    id: "final",
    no: "伍",
    title: "武魂殿 · 最终决战",
    desc: "大陆局势风起云涌，唐三率众迎战武魂殿，为守护宗门与挚爱殊死一搏，故事走向高潮决战。",
    progress: "已收录 · 高潮",
    image: "https://readdy.ai/api/search-image?query=Two%20powerful%20warriors%20clashing%20in%20mid-air%20above%20a%20burning%20ancient%20palace%2C%20energy%20shockwaves%2C%20dramatic%20red%20and%20gold%20lightning%2C%20chinese%20fantasy%20final%20battle%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20epic%20confrontation%2C%20high%20detail&width=800&height=560&seq=arc-final&orientation=landscape",
  },
  {
    id: "god",
    no: "陆",
    title: "成神 · 大结局",
    desc: "历经万难，唐三成就海神之位，守护挚爱与大陆安宁，主篇故事迎来圆满落幕。",
    progress: "主线已完结",
    image: "https://readdy.ai/api/search-image?query=A%20radiant%20figure%20ascending%20toward%20a%20divine%20golden%20light%20in%20the%20sky%20above%20floating%20mountains%2C%20blessing%20rays%2C%20chinese%20fantasy%20apotheosis%2C%20warm%20gold%20and%20cream%20tones%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20peaceful%20triumphant%20mood%2C%20high%20detail&width=800&height=560&seq=arc-god&orientation=landscape",
  },
];